import React, { useState } from "react";
import { Button, FormGroup, FormControl, FormLabel, Alert } from "react-bootstrap";
import { withRouter } from "react-router-dom";

const color = "#229a88";

function ChangePassword(props) {
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  function validateForm() {
    return oldPassword.length > 0 && password.length > 0 && retypePassword.length > 0;
  }

  function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);
    setSuccess("");
    setIsSubmitting(false);
  }

  return (
    <div style={{overflow: "auto"}}>
        <h3 style={{textAlign: "center", color, fontWeight: "bold"}}>Change Password</h3>
        <form onSubmit={handleSubmit}>
            {
                errors.map((error,i) =>
                    <Alert key={i} variant="danger" style={{fontSize: "12px"}}>
                        {error}
                    </Alert>
                )
            }
            {
                success.length > 0 && 
                <Alert variant="success" style={{fontSize: "12px"}}>
                    {success}
                </Alert>
            }
            <FormGroup controlId="phone_number" bssize="large" style={{textAlign: "left"}}>
                <FormLabel>Old Password<span style={{color: "red"}}>*</span></FormLabel>
                <FormControl
                    type="text"
                    placeholder="Old Password"
                    value={oldPassword}
                    size="sm"
                    onChange={e => {
                            setOldPassword(e.target.value);
                            setSuccess("");
                            setErrors([]);
                        }}
                />
            </FormGroup>
            <FormGroup controlId="password" bssize="large" style={{textAlign: "left"}}>
                <FormLabel>New Password<span style={{color: "red"}}>*</span></FormLabel>
                <FormControl
                    value={password}
                    size="sm"
                    onChange={e => {
                        setPassword(e.target.value);
                        setSuccess("");
                        setErrors([]);
                    }}
                    placeholder="New Password"
                    type="password"
                />
            </FormGroup>
            <FormGroup controlId="retypassword" bssize="large" style={{textAlign: "left"}}>
                <FormLabel>Re-Enter New Password<span style={{color: "red"}}>*</span></FormLabel>
                <FormControl
                    value={retypePassword}
                    onChange={e => {
                        setRetypePassword(e.target.value);
                        setSuccess("");
                        setErrors([]);
                    }}
                    size="sm"
                    placeholder="Re-Enter New Password"
                    type="password"
                />
            </FormGroup>
            <div style={{textAlign: "center"}}>
                <Button size="sm" disabled={!validateForm() || isSubmitting ? true:false} type="submit" style={{background: color, borderColor: color, width: "auto", marginLeft: "auto", marginRight: "auto"}} variant="dark">
                    {!isSubmitting ? "Change Password" : "Loading..."}
                </Button>
            </div>
        </form>
    </div>
  );
}

export default withRouter(ChangePassword);